export const AmbassadorContentStop = {
  STOP_TITLE: 'for you?',
  STOP_CONTENT:
    'By becoming a WALDO doctor ambassador, you’ll have an opportunity to benefit from:',
  BENEFITS: [
    {
      title: 'Increased exposure to new audiences',
      content:
        'as well as access to a network of like-minded people in the eyecare industry',
      image: 'increase_exposure.svg',
    },
    {
      title: 'Exclusive access to WALDO products at wholesale price',
      content: 'and 15% discount of all our products',
      image: 'exclusive-access.svg',
    },
    {
      title: 'Financial rewards',
      content:
        'Including an initial introductory payment and other ongoing earning opportunities.',
      image: 'financial-rewards.svg',
    },
  ],
};
